import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CreateYearRequestModel,
  CreateYearResponseModel,
  DeleteYearResponseModel,
  UpdateYearRequestModel,
  UpdateYearResponseModel,
  YearCriteriaRequestModel,
  YearCriteriaResponseModel,
} from '@roi/common/models/water-allocation-years.model';
import { Observable } from 'rxjs';
import { Endpoint } from '../constants/endpoint';
import { TransformTool } from '../tools/transform.tool';

@Injectable({ providedIn: 'root' })
export class YearFetch {
  private http = inject(HttpClient);
  public getByCriteria(
    request: YearCriteriaRequestModel
  ): Observable<YearCriteriaResponseModel> {
    return this.http.get<YearCriteriaResponseModel>(
      `${
        Endpoint.WaterAllocationYear
      }${TransformTool.ConvertObjectToQueryString(request)}`
    );
  }
  public create(
    request: CreateYearRequestModel
  ): Observable<CreateYearResponseModel> {
    return this.http.post<CreateYearResponseModel>(
      `${Endpoint.WaterAllocationYear}`,
      request
    );
  }
  public update(
    request: UpdateYearRequestModel
  ): Observable<UpdateYearResponseModel> {
    return this.http.put<UpdateYearResponseModel>(
      `${Endpoint.WaterAllocationYear}`,
      request
    );
  }
  public delete(id: string): Observable<DeleteYearResponseModel> {
    return this.http.delete<DeleteYearResponseModel>(
      `${Endpoint.WaterAllocationYear}/${id}`
    );
  }
}
